import $ from 'jquery';
import { setSoldOutLabel } from './card-a11y.js';

class FeaturedProduct extends HTMLElement {
  constructor() {
    super();
    this.accessToken = '8bcb2ea2ba9acd5b735e7abe4cbca7d0';
    this.graphUrl =
      'https://liquiddeath.myshopify.com/api/2025-07/graphql.json';

    this.product = $(this).data('handle');
    this.options = $(this).find('#product-options');

    this.productData = null;
    this.selectedColor = null;
  }
  async connectedCallback() {
    if (this.querySelector("[data-product-popup]")) return;
    try {
      const response = await fetch(this.graphUrl, {
        async: true,
        crossDomain: true,
        method: 'POST',
        headers: {
          'X-Shopify-Storefront-Access-Token': this.accessToken,
          'Content-Type': 'application/graphql',
        },
        body: this.productQuery(),
      });

      const res = await response.json();
      this.productData = res.data.product;
      this.selectedColor =
        this.productData.options.filter(
          (option) => option.name.toLowerCase() == 'color'
        )[0]?.values[0] || null;

      this.renderOptions();
      this.changeVariant();
      this.checkAvailability();
      this.addToCart();
    } catch (err) {
      console.error('Error fetching product data:', err);
    }
  }

  productQuery() {
    return `query {
              product(handle: "${this.product}") {
                title
                handle
                featuredImage {
                  url
                  id
                }
                variants(first: 100) {
                  edges {
                    node {
                      id
                      price {
                        amount
                      }
                      title
                      availableForSale
                      quantityAvailable
                      image {
                        url
                        id
                      }
                    }
                  }
                }
                options {
                  name
                  values
                }
              }
            }`;
  }

  decodeId(id) {
    const shopifyId = id.split('/').pop();
    return parseInt(shopifyId);
  }

  renderOptions() {
    let html = `
    <div class="flex flex-col">`;

    this.productData.options.forEach((option) => {
      if (this.productData.options[0].name !== 'Title') {
        html += `<div class="${
          option.name.toLowerCase() !== 'color' &&
          option.name.toLowerCase() !== 'size'
            ? 'product__option-size'
            : `product__option-${option.name.toLowerCase()}`
        } ${option.values.length == 1 && '!hidden'} ${
          option.name.toLowerCase() == 'color' && '!hidden'
        }">
                  <div class="product__option-title text-dark ${
                    option.values.length == 1 && '!hidden'
                  } " id="FeaturedOptionTitle-${this.dataset.handle}-${option.name.replaceAll(' ', '-')}" data-name="${option.name}">
                  ${
                    option.name.toLowerCase() !== 'color' &&
                    option.name.toLowerCase() !== 'size'
                      ? ''
                      : 'Select'
                  } ${option.name}: <span>${
          option.name.toLowerCase() == 'color'
            ? this.selectedColor ||
              this.productData.options.filter(
                (opt) => opt.name.toLowerCase() == 'color'
              )[0]?.values[0]
            : ''
        }</span></div>
                                <div role="radiogroup" aria-labelledby="FeaturedOptionTitle-${this.dataset.handle}-${option.name.replaceAll(' ', '-')}" class="product__options-wrap items-center flex flex-wrap mt-4 ${
                                  option.values.length == 1 && 'mt-0'
                                }">`;
        if (option.name.toLowerCase() !== 'color') {
          option.values.forEach((size) => {
            html += `<input type="radio" name="option-${
              option.name
            }" id="option-${size.replaceAll(' ', '-')}" data-name="${
              option.name
            }" value="${size}" class="sr-only" ${
              option.values.length == 1 && 'checked'
            } />
                                        <label for="option-${size.replaceAll(
                                          ' ',
                                          '-'
                                        )}" class="${
              option.values.length == 1 && 'hidden'
            } product__size-option text-base mb-2 flex text-dark border border-solid border-dark p-1 min-w-[52px] m-[3px] h-10 items-center justify-center cursor-pointer" data-name="${size}"><span class="p-1 bg-white z-10">${size}</span></label>`;
          });

          html += `<div class="size-error hidden w-full mt-1">Please ${
            option.name.toLowerCase() !== 'size'
              ? `${option.name}`
              : 'select size'
          }</div>`;
        }
        if (option.name.toLowerCase() == 'color') {
          let selected =
            this.selectedColor ||
            this.productData.options.filter(
              (opt) => opt.name.toLowerCase() == 'color'
            )[0]?.values[0];
          option.values.forEach((color) => {
            let color_val = color
              .toLowerCase()
              .replaceAll(' ', '-')
              .replaceAll('/', '-');
            html += `<input type="radio" name="option-${option.name}" ${
              color == selected && 'checked'
            } id="option-${color_val}" data-name="${
              option.name
            }" value="${color}" class="sr-only" />
                                        <label for="option-${color_val}" class="swatch ${color_val} h-5 w-5 mr-4" data-product="${
              this.productData.title
            }" data-name="${
              option.name
            }" style="background: ${color_val}"><span class="sr-only">${color}</span></label>`;
          });
        }
        html += `</div>
                            </div>`;
      }
    });
    html += `</div>
                  <div class="flex mt-6">
                    <div class='animated-button-block-hero w-full h-14'>
                        <button class='product__cta font-bold button-white block uppercase text-base w-full ${
                          this.productData.options.filter(
                            (option) => option.name.toLowerCase() == 'size'
                          ).length > 0
                            ? ''
                            : 'active'
                        }'>
                            ${
                              this.productData.options.filter(
                                (option) => option.name.toLowerCase() == 'size'
                              ).length > 0
                                ? 'Select Size'
                                : 'add to cart'
                            }
                        </button>
                    </div>
                  </div>
                </div>
              </div>
             `;
    this.options.append(html);
  }

  changeVariant() {
    // change option

    this.querySelector('#product-options').addEventListener('change', (e) => {
      var targetName = e.target.getAttribute('data-name');
      var optionTitleSelector =
        '.product__option-title[data-name="' + targetName + '"] span';
      var optionTitle = this.querySelector(optionTitleSelector);
      optionTitle.textContent = e.target.value;

      var variant = this.productData.variants.edges.filter(function (variant) {
        return variant.node.title.includes(e.target.value);
      })[0].node;

      var priceMain = this.querySelector('#price__main');
      priceMain.textContent = '$' + Number(variant.price.amount).toFixed(2);

      this.checkAvailability();

      if (e.target.getAttribute('data-name') == 'Color') {
        var changeSlider = new CustomEvent('changeSlider', {
          bubbles: true,
          cancelable: true,
          composed: true,
          detail: {
            media_id: variant.image.url,
            transition_speed: 1000,
          },
        });

        this.dispatchEvent(changeSlider);
      }
    });
    $(document).off('click');
  }

  decodeId(id) {
    const shopifyId = id.split('/').pop();
    return parseInt(shopifyId);
  }

  checkAvailability() {
    var sizeOptions = this.querySelectorAll('.product__size-option');
    sizeOptions.forEach((option) => {
      option.classList.remove('disabled');
      option.classList.remove('clickable-disabled');
      setSoldOutLabel(option, false);
      // Remove any existing click handlers
      option.removeEventListener('click', this.handleUnavailableVariantClick);
    });

    var selectedColor = this.querySelector(
      '.product__option-color input:checked'
    )?.value;
    var unavailableVariants = this.productData.variants.edges.filter(
      (variant) => {
        return (
          variant.node.title.includes(selectedColor) &&
          !variant.node.availableForSale
        );
      }
    );

    if (unavailableVariants.length) {
      unavailableVariants.forEach((variant) => {
        var title = variant.node.title
          .replace(selectedColor, '')
          .replace('/', '')
          .trim();
        var disabledOption = this.querySelector(
          '.product__size-option[data-name="' + title + '"]'
        );
        if (disabledOption) {
          disabledOption.classList.add('disabled');
          disabledOption.classList.add('clickable-disabled'); // Override pointer-events: none
          setSoldOutLabel(disabledOption, true);
          // Add click handler for unavailable variants
          disabledOption.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleUnavailableVariantClick(variant);
          });
        }
      });
    }

    var colorOptions = this.querySelector('.product__option-color');
    if (colorOptions) {
      var soldVariants = this.productData.variants.edges.filter((variant) => {
        return (
          variant.node.title.includes(selectedColor) &&
          variant.node.availableForSale
        );
      });

      if (!soldVariants.length) {
        var productCta = this.querySelector('.product__cta');
        if (productCta) {
          productCta.textContent = 'sold out';
          productCta.classList.remove('active');
        }
      }
    } else {
      var availableVariants = this.productData.variants.edges.filter(
        (variant) => {
          return variant.node.availableForSale;
        }
      );

      if (!availableVariants.length) {
        var productCta = this.querySelector('.product__cta');
        if (productCta) {
          productCta.textContent = 'sold out';

          productCta.classList.remove('active');
        }
      }
    }

    var selectedVariants = this.productData.variants.edges;
    if (selectedVariants.length > 1) {
      var sizeInputs = this.querySelectorAll(
        '.product__option-size .product__options-wrap input:checked'
      );
      sizeInputs.forEach(function (input, i) {
        selectedVariants = selectedVariants.filter(function (variant) {
          return variant.node.title.split(' / ').some(function (title) {
            return title.trim() === input.value;
          });
        });
      });
    }

    if (!selectedVariants[0]?.node.availableForSale) {
      var productCta = this.querySelector('.product__cta');
      if (productCta) {
        if (
          this.querySelectorAll('.product__option-size input:checked').length
        ) {
          productCta.textContent = 'sold out';
        }
        productCta.classList.remove('active');
      }
    } else {
      var productCta = this.querySelector('.product__cta');
      if (
        productCta &&
        this.querySelectorAll('.product__option-size input:checked').length
      ) {
        productCta.textContent = 'add to cart';
        productCta.classList.add('active');
      }
    }
  }

  addToCart() {
    var productOptions = this.querySelector('#product-options');
    productOptions.addEventListener('click', (e) => {
      if (e.target.classList.contains('product__cta')) {
        var productOptionTitles = this.querySelectorAll(
          '.product__option-title'
        );
        productOptionTitles.forEach((option) => {
          option.classList.remove('hidden');
        });
        // this.querySelector('product-tabs').classList.remove('hidden');
        // this.querySelector('product-tabs').classList.add('block');
      }

      if (
        e.target.classList.contains('product__cta') &&
        e.target.classList.contains('active')
      ) {
        //add to cart
        var variants = this.productData.variants.edges;
        if (variants.length > 1) {
          var sizeInputs = this.querySelectorAll(
            '.product__option-size .product__options-wrap input:checked'
          );
          sizeInputs.forEach(function (input, i) {
            variants = variants.filter(function (variant) {
              return variant.node.title.split(' / ').some(function (title) {
                return title.trim() === input.value;
              });
            });
          });
        }

        var id = this.decodeId(variants[0].node.id);
        var formData = {
          items: [
            {
              id: id,
              quantity: 1,
            },
          ],
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then(function (response) {
            if (window.Shopify.customerPrivacy.marketingAllowed()) {
              amzn('trackEvent', 'AddToShoppingCart');
            }
          })
          .catch(function (error) {
            console.error('Error:', error);
          });
      }
    });
  }

  /**
   * Handle click on unavailable variant size option
   * Opens Klaviyo BIS modal for that specific variant
   */
  handleUnavailableVariantClick(variant) {
    const productId = this.decodeId(this.productData.id);
    const variantId = this.decodeId(variant.node.id);

    // Create a specific Klaviyo BIS modal for this variant
    const klaviyoBisHTML = `
      <div class="general-klaviyo-modal" product-id='${productId}'>
        <div class='klaviyo-bis-modal-overlay fixed inset-0 overflow-y-auto flex items-center justify-center' aria-labelledby='modal-title' role='dialog' aria-modal='true' style='background-color: rgba(0, 0, 0, 0.5); z-index: 999999;'>
          <div id='klaviyo-bis-modal' class='relative'>
            <div class='bg-white relative' style='padding: 32px 18px 40px 18px; max-width: 460px;' id='container'>
              <button type='button' class='close klaviyo-bis-close' data-dismiss='modal' style='position: absolute; top: 10px; right: 15px; font-size: 24px; background: none; border: none; cursor: pointer;'>×</button>
              <h3 class='modal-title'>${this.productData.title}</h3>
              <p>Get notified when <strong>${variant.node.title}</strong> is back in stock.</p>
              <form action='#' class='form-horizontal clearfix' id='general-klaviyo-form'>
                <div class='form-group' style='margin-bottom: 15px;'>
                  <div class='col-sm-12'>
                    <input required type='email' id='email' placeholder='Email' class='form-control input-lg' value=''>
                  </div>
                  <div id='newsletter_subscription' style='display: none;'>
                    <p>
                      <input type='checkbox' id='subscribe_for_newsletter' checked=''>
                      <label for='subscribe_for_newsletter' style='margin-left:10px;'>Add me to your email list.</label>
                    </p>
                  </div>
                </div>
                <div class='control-group clearfix submit-container'>
                  <button type='submit' class='btn btn-notify btn-success btn-lg col-xs-12 hover:!bg-gold'>Notify me when available</button>
                </div>
                <p class='text-sm'>
                  By clicking "Notify Me" you agree to be brainwashed by Liquid Death marketing through rare
                  (but hilarious) emails and agreeing to our
                  <a class=' underline' href='/policies/privacy-policy'>Terms & Conditions</a> /
                  <a class=' underline' href='/policies/terms-of-service'>Privacy Policy</a>
                </p>
                <div id='error_message' class='error_message alert alert-danger hidden'></div>
                <div id='completed_message' class='completed_message alert alert-success hidden'>
                  You're in! We'll let you know when it's back. <a href='#' class='klaviyo-bis-close'>Close</a>
                </div>
              </form>
              <p class='small-print'></p>
            </div>
          </div>
        </div>
      </div>
    `;

    // Insert the modal into the page
    document.body.insertAdjacentHTML('beforeend', klaviyoBisHTML);

    // Add event listeners for modal close functionality
    this.setupGeneralModalCloseListeners(variantId, productId);
  }

  /**
   * Sets up event listeners for the general Klaviyo BIS modal
   */
  setupGeneralModalCloseListeners(variantId, productId) {
    // Close button
    const closeButtons = document.querySelectorAll('.klaviyo-bis-close');
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.closeGeneralModal();
      });
    });

    // Close on overlay click
    const modalOverlay = document.querySelector('.klaviyo-bis-modal-overlay');
    if (modalOverlay) {
      modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
          this.closeGeneralModal();
        }
      });
    }

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const modalOverlay = document.querySelector(
          '.klaviyo-bis-modal-overlay'
        );
        if (modalOverlay && !modalOverlay.classList.contains('hidden')) {
          this.closeGeneralModal();
        }
      }
    });

    // Handle notify button click
    const notifyButton = document.querySelector(
      '#general-klaviyo-form .btn-notify'
    );
    if (notifyButton) {
      notifyButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleGeneralKlaviyoFormSubmit(e, variantId, productId);
      });
    }
  }

  /**
   * Close the general Klaviyo BIS modal
   */
  closeGeneralModal() {
    const modalElement = document.querySelector('.general-klaviyo-modal');
    if (modalElement) {
      modalElement.remove();
    }
  }

  /**
   * Handle form submission for the general Klaviyo BIS modal
   */
  async handleGeneralKlaviyoFormSubmit(e, variantId, productId) {
    const form = document.querySelector('#general-klaviyo-form');
    if (!form) return;

    const emailInput = form.querySelector('#email');

    if (!emailInput) {
      console.error('Email input not found');
      return;
    }

    const email = emailInput.value.trim();

    if (!email) {
      alert('Please enter your email address');
      return;
    }

    try {
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      const response = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Ntc5BJ',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        console.log('✅ Klaviyo API call successful');
        // Show success message
        const successMessage = form.querySelector('#completed_message');
        if (successMessage) {
          successMessage.classList.remove('hidden');
        }
      } else {
        console.error('❌ Klaviyo API call failed:', response.status);
        const errorText = await response.text();
        console.error('Error response:', errorText);
        alert('There was an error submitting your request. Please try again.');
      }
    } catch (error) {
      console.error('Error calling Klaviyo API:', error);
      alert('There was an error submitting your request. Please try again.');
    }
  }
}
customElements.define('featured-product', FeaturedProduct);
